import React from 'react'
import { useDataContext } from "context/DataContext"
import DefaultCard from 'components/card/DefaultCard'
import './MetaInfo.scss'

const MetaInfo: React.FC = () => {
    const {tumor, fileName} = useDataContext()

    const primaryTumorSite = tumor?.primaryTumorSite?.trim() || ''
    const histologyType = tumor?.histologyType?.trim() || ''
    const tumorset = [primaryTumorSite, histologyType].filter(Boolean).join(', ')

    const tumorsetMissing = !primaryTumorSite || !histologyType

    return (
        <DefaultCard className='metaInfoCard'>
            <div className='metaInfoRow'>
                <div className='metaInfoItem'>
                    <div className='metaInfoLabel'>Tumorset</div>
                    <div className='metaInfoValue' title={tumorset}>{tumorset}</div>
                    {tumorsetMissing && (
                        <div className="metaInfoError">Tumorset data is missing in this file.</div>
                    )}
                </div>
                <div className='metaInfoItem'>
                    <div className='metaInfoLabel'>File name</div>
                    <div className='metaInfoValue' title={fileName}>{fileName}</div>
                </div>
            </div>
        </DefaultCard>
    )
}

export default MetaInfo